import $ from 'jquery';
import 'select2';
import 'jquery.easing';
import 'Inputmask';
import 'jquery-validation';
import Handlebars from 'handlebars/dist/cjs/handlebars';

// 2021.09.30

$('.gas-calculator').each((i, el) => {
  const $el = $(el);

  // Calculator functionality
  // ------------------------------------------------------------------------ //

  // Inputs
  const $rateForm = $el.find('.calculator-converter-form');
  const $Amount = $el.find('#Amount');
  const $SellCurrency = $el.find('#SellCurrency');
  const $BuyCurrency = $el.find('#BuyCurrency');

  // Outputs
  const $outputSuccess = $el.find('.calculator-output-success');
  const $outputError = $el.find('.calculator-output-error');
  const $outputCalc = $el.find('.gas-calculator-output');
  const $calculatorSpinner = $el.find('.gas-calculator-spinner');
  // Actions
  const $InvertCurrency = $el.find('#InvertCurrency');
  const $CalculateBtn = $el.find('#CalculateBtn');
  // API URL build
  const calcAPI = $rateForm.data('api-root') + $rateForm.data('api-url');
  // Keep track if taking values from left to right with form inputs or the other way
  let isReversed = false;

  // Auto-format inputs to currency
  $Amount.inputmask();

  // Enable select2
  $SellCurrency.select2({
    templateResult: templateResultCurrency,
    templateSelection: templateSelectionCurrency
  });

  $BuyCurrency.select2({
    templateResult: templateResultCurrency,
    templateSelection: templateSelectionCurrency
  });

  function templateSelectionCurrency(country, notList) {
    notList = notList ? true : false;
    if (!country.id) {
      return country.text;
    }
    var countryCode = country.element.value.toLowerCase();
    var countrySym = country.id;
    var countryName = country.text.slice(country.text.lastIndexOf('-') + 1).trim();
    var $country = $(
      '<span class="currency-select"><i class="flag-icon flag-icon-' + countryCode.slice(0, 2) + '" /></i><span class="curr-opt-items"><span class="curr-sym">' + countrySym + (notList ? '' : ' -&nbsp;') + '</span><span>' + countryName + '</span></span></span>'
    );
    return $country;
  }

  function templateResultCurrency(country) {
    return templateSelectionCurrency(country, false);
  }

  function showRateError() {
    $outputSuccess.hide();
    $outputError.show();
  }

  function clearRateError() {
    $outputSuccess.show();
    $outputError.hide();
  }

  function getRate() {
    $calculatorSpinner.show();
    const amount = $Amount.val();
    const fromCurrency = isReversed ? $BuyCurrency.val() : $SellCurrency.val();
    const toCurrency = isReversed ? $SellCurrency.val() : $BuyCurrency.val();

    if (isReversed) {
      $SellCurrency.val(fromCurrency);
      $SellCurrency.select2({
        templateResult: templateResultCurrency,
        templateSelection: templateSelectionCurrency
      });

      $BuyCurrency.val(toCurrency);
      $BuyCurrency.select2({
        templateResult: templateResultCurrency,
        templateSelection: templateSelectionCurrency
      });

      isReversed = false;
    }

    // call API
    $.ajax({
      method: 'GET',
      url: `${calcAPI}${fromCurrency}/${toCurrency}`
    })
      .done(json => {
        $calculatorSpinner.hide();
        clearRateError();
        var data = json[0];
        data.FromCurrencyAmount = amount;
        data.FromCurrency = fromCurrency;
        data.FromCurrencySymbol = $SellCurrency.find(":selected").data("symbol");
        data.FromCurrencyName = $SellCurrency.find(":selected").text();
        data.ToCurrencyAmount = (data.Rate * data.FromCurrencyAmount).toFixed(2);
        data.ToCurrency = toCurrency;
        data.ToCurrencySymbol = $BuyCurrency.find(":selected").data("symbol");
        data.ToCurrencyName = $BuyCurrency.find(":selected").text();
        data.InverseRate = (1 / data.Rate).toFixed(8);

        let calculatorResultTemplate = $('#gas-calculator-result-template');
        var template = Handlebars.compile(calculatorResultTemplate.html());
        $outputSuccess.html($.parseHTML(template(data)));
        // Handlebars.compile(tmpl.html())

        //// Left output
        //$outputValueFrom.html(data.ResultFrom);
        //$outputKindFrom.html($('#currency-kind-from option:selected').text());
        //// Right output
        //$outputValueTo.html(data.ResultTo);
        //$outputKindTo.html($('#currency-kind-to option:selected').text());
        //// Rate
        //$outputUnitRate.html(data.ResultUnitConversion);
        //$outputInvUnitRate.html(data.ResultUnitConversionReverse);

      })
      .fail(() => {
        $calculatorSpinner.hide();
        showRateError();
      });

    // call GTM
    var eobj = { amount: amount, from: fromCurrency, to: toCurrency };
    callGTM('getRate', eobj);
  }

  // Bind
  // ----------------------------------------- //
  $CalculateBtn.on('click', e => {
    isReversed = false;
    getRate();
    $outputCalc.addClass('is-open');
    // WCAG
    $outputCalc.attr('aria-hidden', false);
    $CalculateBtn.attr('aria-expanded', true);
  });
  // Swap
  $InvertCurrency.on('click', () => {
    isReversed = true;
    getRate();
  });

  // Open close functionality
  // ------------------------------------------------------------------------ //
  const $ctaBtn = $el.find('.calculator-cta');
  let isOpen = false;
});

// Send data to Google Tag Manager via event
function callGTM(ename, eobj) {
  var gtmstr = 'window.dataLayer = window.dataLayer || [];';
  gtmstr += 'window.dataLayer.push({';
  if (typeof eobj != "undefined") {
    gtmstr += "'event': '" + ename + "',";
    if (Object.keys(eobj).length > 0 && eobj.constructor === Object) {
      var currPairCode = eobj.amount + "-" + eobj.from + "-to-" + eobj.to;
      gtmstr += "'currPairCode': '" + currPairCode + "',";
      gtmstr += "'currVal': '" + eobj.amount + "',";
      gtmstr += "'currFrom': '" + eobj.from + "',";
      gtmstr += "'currTo': '" + eobj.to + "',";
    }
  } else if (ename == "rateAlertSuccess") {
    gtmstr += "'event':'" + ename + "',";
  }
  gtmstr += '});'; //some arbitrary name for the page/state
  if (typeof gtmstr !== 'undefined' && gtmstr.length > 0)
    eval(gtmstr);
}
